<template>
	<div class="dialog" v-if="showPop">
		<div class="dialog-content">
			<xt-tick :content="content"></xt-tick>
			<xt-button v-if="showBtn" @click="saveConfirm" v-track-click="{eventId: 'registFinishMoblie', title: '账号注册成功' }"><slot/></xt-button>
		</div>
	</div>
</template>
<script>
  import XtButton from "./xtButton";
  import XtTick from "./xt-tick";
	export default {
    components: {XtTick, XtButton},
    props:{
			showPop:{
			  type: Boolean,
				default: false
			},
			content:{
			  type:String,
				default: '保存成功'
			},
			onConfirm:{
			  type: Function,
				request: false
			},
      showBtn:{
			  type: Boolean,
				default: true
			}
		},
		methods:{
      async saveConfirm(){
        if (this.onConfirm && typeof this.onConfirm === 'function') {
          await this.onConfirm()
        } else {
					this.showPop = false
        }
			}
		}
	}
</script>
<style lang="less" scoped>
	.dialog {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		z-index: 99999999999;
		margin: 0;
		background: rgba(0, 0, 0, 0.75);
		.dialog-content {
			margin-top: 20vh;
			margin-left: auto;
			margin-right: auto;
      width: 320px;
			min-height: 100px;
			border-radius: 10px;
			background: #FFF;
			box-sizing: border-box;
			padding: 26px 27px 45px 27px;
			position: relative;
			display: flex;
			flex: 1;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.success-png {
				width: 60px;
				height: 60px;
				background: #D9E9FF;
				border-radius: 30px 30px;
				.success-v {
					width: 30px;
					height: 15px;
					border: 3px solid #4C7EC5;
					border-right: none;
					border-top: none;
					transform: rotate(-45deg) translateX(-2px) translateY(23px);
				}
			}
			.success-text {
				margin-top: 20px;
				margin-bottom: 20px;
				font-size: 21px;
				font-weight: 600;
				line-height: 30px;
			}
		}
	}
</style>